const outlineVariant = {
    control: {
        _checked: {
            borderColor: 'stroke.interactive',
            bg: 'transparent',
            _before: {
                bg: 'stroke.interactive'
            },
            _hover: {
                bg: 'transparent',
                borderColor: 'stroke.interactive'
            }
        },
        _disabled: {
            bg: 'transparent',
            borderColor: 'stroke.medium',
            color: 'text.tertiary',
            cursor: 'not-allowed',
            _hover: {
                borderColor: 'stroke.medium'
            }
        },
        _focusVisible: {
            borderColor: 'stroke.interactive'
        },
        _hover: {
            bg: 'transparent',
            borderColor: 'stroke.interactive'
        },
        _invalid: {
            borderColor: 'stroke.error',
            _checked: {
                borderColor: 'stroke.error',
                bg: 'transparent',
                _before: {
                    bg: 'stroke.error'
                }
            }
        },
        bg: 'transparent',
        border: '2px solid',
        borderColor: 'stroke.dark',
        height: '1.5rem',
        p: 0.2,
        textStyle: 'm',
        width: '1.5rem'
    },
    label: {
        textStyle: 'm',
        color: 'text.primary',
        _disabled: {
            color: 'text.tertiary',
            cursor: 'not-allowed'
        }
    }
};
export const Radio = {
    parts: [
        'control',
        'label'
    ],
    variants: {
        outline: outlineVariant
    }
};

//# sourceMappingURL=radio.js.map